import React, { useContext } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { Button, DatePicker, Space, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

import AuditLogContext from '@totem/components/services/remoteAccess/auditLog/AuditLogContext';
import AuditLogSearch from '@totem/components/services/remoteAccess/auditLog/AuditLogSearch';
import { AuditLogEntry } from '@totem/components/services/remoteAccess/auditLog/types';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const COLUMNS: ColumnsType<AuditLogEntry> = [
  {
    title: 'Date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 180,
    render: (val: string) => dayjs(val).format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
  },
  {
    title: 'Role',
    dataIndex: 'object',
    key: 'object',
  },
  {
    title: 'Assignee',
    dataIndex: 'assignee',
    key: 'assignee',
  },
  {
    title: 'User',
    dataIndex: 'user',
    key: 'user',
  },
];

export const AuditLogExtra = () => {
  const {
    paging,
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange,
    onRefresh,
  } = useContext(AuditLogContext);

  return (
    <Space>
      <DatePicker
        placeholder="Start date"
        value={startDate}
        onChange={onStartDateChange}
        allowClear
      />
      <DatePicker
        placeholder="End date"
        value={endDate}
        onChange={onEndDateChange}
        allowClear
      />
      <RecordCountBadge count={paging.totalRecords} />
      <Tooltip title="Refresh">
        <Button icon={<ReloadOutlined />} onClick={onRefresh} />
      </Tooltip>
    </Space>
  );
};

const AuditLogLayout = () => {
  const { loading, data, paging, onPageChange } = useContext(AuditLogContext);

  return (
    <>
      <AuditLogSearch />
      <br />
      <Table
        rowKey={(row, idx) => `${row.createdAt}-${idx}`}
        columns={COLUMNS}
        dataSource={data}
        loading={loading}
        pagination={{
          current: paging.page,
          pageSize: paging.pageSize,
          total: paging.totalRecords,
          showSizeChanger: true,
          onChange: onPageChange,
        }}
        size="small"
      />
    </>
  );
};

export default AuditLogLayout;
